<div #container [ngClass]="{ 'loading': loading }">
  <mat-spinner class="spinner" [diameter]="diameter" *ngIf="loading"></mat-spinner>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
